export default __webpack_public_path__ + "static/media/time.a4ccd551.svg";